import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import LogoutModal from '../LogoutModal/LogoutModal';
import userIcon from '../../assets/icons/user-login-icon.svg';
import './UserMenu.scss';

const UserMenu = () => {
  const { t } = useTranslation('common');
  const [isOpen, setIsOpen] = useState(false);
  const [showLogoutModal, setShowLogoutModal] = useState(false);

  const toggleMenu = () => setIsOpen(!isOpen);
  const handleLogoutClick = () => {
    setIsOpen(false);
    setShowLogoutModal(true);
  };

  return (
    <div className="user-menu">
      <button 
        className={`user-menu__trigger ${isOpen ? 'is-open' : ''}`}
        onClick={toggleMenu}
        aria-expanded={isOpen}
      >
        <img src={userIcon} alt="" className="user-menu__icon" />
      </button>

      {isOpen && (
        <div className="user-menu__dropdown">
          <Link 
            to="/profile" 
            className="user-menu__item"
            onClick={() => setIsOpen(false)}
          >
            {t('userMenu.profile')}
          </Link>
          <button 
            className="user-menu__item"
            onClick={handleLogoutClick}
          >
            {t('userMenu.logout')}
          </button>
        </div>
      )}

      <LogoutModal 
        isOpen={showLogoutModal} 
        onClose={() => setShowLogoutModal(false)} 
      />
    </div>
  );
};

export default UserMenu;
